define('setup/setup-store',['require','lib/auth/auth','api-access','api-access','api-access','web-urls','lodash','cookie-handler','lib/multivariate-testing/multivariate-testing'],function (require) {
    var auth = require('lib/auth/auth');
    var user = require('api-access').user;
    var adminApi = require('api-access').extadmin;
    var gotomeet = require('api-access').gotomeet;
    var webUrls = require('web-urls');
    var _ = require('lodash');
    var cookies = require('cookie-handler');
    var multivariateTesting = require('lib/multivariate-testing/multivariate-testing');

    return {
        update: function () {
            return gotomeet.getByUserKey().then(function (profileData) {
                return _.extend({}, profileData, {
                    profileUrl: [webUrls.get('gotoMeetMeUrl'), profileData.profileId].join('/')
                });
            })
            .fail(function () {
                return {};
            });
        },

        // this function makes the calls needed for the given page
        // that way they are in the caching layer when the page
        // makes those calls
        prefetch: function (page) {
            // remove #setup/ or /setup/ from the next url to get the page name
            var key = page.replace(/(#|\/)?setup\//i, '');
            var fetchers = {
                'admin-audio': function () {
                    return $.when(
                        user.me(),
                        user.settings()
                    ).then(function (meResponse, settingsResponse) {
                        var me = meResponse[0];
                        var settings = settingsResponse[0];
                        return $.when(
                            adminApi.getAllowedTFCountries(me.accountKey, settings.tierName),
                            adminApi.getProductSettings(me.accountKey, settings.tierName),
                            adminApi.getDefaultTemplate(me.accountKey)
                        );
                    });
                }
            };

            // if we don't have the page in our map or we haven't fetched, then we
            // don't know how to pre-fetch or the page doesn't need anything
            // that we can pre-fetch
            if (!fetchers[key]) {
                return $.Deferred().resolve();
            }

            return fetchers[key]();
        },

        fetch: function () {
            var promise = $.Deferred();
            var config = {
                isAuthenticated: !!auth.getToken()
            };

            if (!config.isAuthenticated) {
                return promise.resolve(config);
            }

            var productSettings;
            var userData;
            var settings;
            var adminMe;
            var profileUrl;
            var product = {};
            var isAdmin;
            var isG2MMSchedulingTest;

            var baseCalls = $.Deferred();
            var productCall = $.Deferred();
            var gotoMeetCall = $.Deferred();

            var extAdminDown = false;
            var goToMeetMeDown = false;

            var getUserSettings = function () {
                var allCalls = $.when(
                    user.me(),
                    user.settings(),
                    multivariateTesting.checkVariation('g2mmSchedulingTest')
                );

                return allCalls.then(function (userResp, settingsResp, g2mmSchedulingTestVariation) {
                    userData = userResp[0];
                    settings = settingsResp[0];
                    isAdmin = _.contains(userData.grantedAuthorities, 'ROLE_EXT_ADMIN');
                    isG2MMSchedulingTest = g2mmSchedulingTestVariation === 'variation-a';
                });
            };

            var getExtAdminSettings = function (tier) {
                if (!isAdmin || extAdminDown) {
                    return baseCalls.resolve();
                }

                // for admins we need to load the external admin
                // default template settings
                var loadAdminSettings = $.when(
                    adminApi.getProductSettings(userData.accountKey, tier),
                    adminApi.getDefaultTemplate(userData.accountKey),
                    adminApi.getMe()
                );

                return loadAdminSettings
                    .then(function (settingsResponse, template, adminMeResp) {
                        productSettings = _.extend({}, template, settingsResponse);
                        adminMe = adminMeResp;
                    })
                    .fail(function () {
                        // in this case we should keep going, with all the external
                        // data turned off and mark external admin as down
                        extAdminDown = true;
                        productSettings = {};
                        adminMe = {};
                    })
                    .always(function () {
                        return baseCalls.resolve();
                    });
            };

            user.getServiceStatus().then(function (status) {
                extAdminDown = !status['extadmin-service'].up;
                goToMeetMeDown = !status['gotomeetme-service'].up;
            }).then(function () {
                getUserSettings()
                    .then(function () {
                        return getExtAdminSettings(settings.tierName);
                    })
                    // if we can't get the basic user info, we
                    // can't do anything and we should reject the whole thing
                    .fail(baseCalls.reject);

                user.product()
                    .then(function (productsResp) {
                        product = productsResp;
                    })
                    .always(function () {
                        productCall.resolve();
                    });

                if (!goToMeetMeDown) {
                    gotomeet
                        .getByUserKey()
                        .then(function (profileData) {
                            profileUrl = [webUrls.get('gotoMeetMeUrl'), profileData.profileId].join('/');
                        })
                        .fail(function (err) {
                            // if there is no profile, it will return empty with status 200
                            // we say the G2MM is down if http status is not 200
                            goToMeetMeDown = err.status !== 200;
                        })
                        .always(function () {
                            gotoMeetCall.resolve();
                        });
                } else {
                    gotoMeetCall.resolve();
                }
            });

            // if we landed through the /#reserve url, it means we need to land on PL
            // and we should only see the reserve page (old workflow)
            var reserveOnly = !!cookies.get('reserve');
            var g2mJudo = !!cookies.get('g2m-judo');

            cookies.clear('reserve');
            cookies.clear('g2m-judo');

            var finalCalls = $.when(
                baseCalls,
                productCall,
                gotoMeetCall
            );

            finalCalls
                .then(function () {
                    return _.extend(config, {
                        goToMeetMeDown: goToMeetMeDown,
                        extAdminDown: extAdminDown,
                        profileUrl: profileUrl,
                        isAdmin: isAdmin,
                        isBillingAdmin: userData.key === product.billingAdminUserKey,
                        canManageSettings: _.contains(_.get(adminMe, 'adminRoles'), 'MANAGE_SETTINGS'),
                        isTrial: product.trial,
                        productSettings: productSettings,
                        settings: settings,
                        user: userData,
                        reserveOnly: reserveOnly,

                        // this flag is for free but trial users
                        isFreeTrial: settings.marketingChannel === 'g2m-judo' || g2mJudo,
                        isG2MMSchedulingTest: isG2MMSchedulingTest
                    });
                })
                .then(promise.resolve)
                .fail(promise.reject);

            return promise;
        }
    };
});

